import React from "react";
import { Button, Title } from "../../../components";

interface Props {
  title: string;
  description: string;
  buttonLabel: string;
  onClick: () => void;
}

const HomeGoToFooter: React.FC<Props> = (props): React.ReactElement => {
  const { buttonLabel, description, title, onClick } = props;

  return (
    <div className="mb-8 mt-4 flex flex-col justify-between sm:flex-row sm:items-center">
      <div className="mb-2 sm:mb-0">
        <Title title={title} size="small" />
        <p className="small">{description}</p>
      </div>
      <Button label={buttonLabel} size="small" onClick={onClick} />
    </div>
  );
};

export default HomeGoToFooter;
